import { API_URL } from '../config/connect';

const deletePromotion = async (promotionId) => {
    const googleIdToken = localStorage.getItem("google_id_token");

    if (!googleIdToken) {
        throw new Error("No token found. User is not signed in.");
    }

    try {
        const response = await fetch(`${API_URL}/api/v1/admin/promotion/${promotionId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${googleIdToken}`,
            },
        });

        if (!response.ok) {
            const errorBody = await response.json().catch(() => ({ message: response.statusText }));
            const errorMessage = errorBody.detail?.[0]?.msg || errorBody.message || JSON.stringify(errorBody);
            throw new Error(`Error ${response.status}: ${errorMessage}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting promotion:', error);
        throw error;
    }
};

export default deletePromotion;

